import { render, staticRenderFns } from "./referenzen-kunden-4.vue?vue&type=template&id=022a2597&"
import script from "./referenzen-kunden-4.vue?vue&type=script&lang=js&"
export * from "./referenzen-kunden-4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports